import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import styled from "styled-components";
import ListComponent from "../../components/ListComponent";

const data = [
    {
        id: 1,
        title: 'Introduction to Modern Architecture',
        instructor: 'Dr. Jane Smith',
        duration: '45 minutes',
        date: 'September 10, 2024',
        summary: 'This lecture provides an overview of modern architecture, tracing its origins from the late 19th century to contemporary practices.',
        topics: [
            'Origins of Modern Architecture',
            'Key Figures: Frank Lloyd Wright, Le Corbusier, Mies van der Rohe',
            'Defining Characteristics of Modernist Design',
            'Impact on Urban Development'
        ]
    },
    {
        id: 2,
        title: 'Sustainable Building Design',
        instructor: 'Prof. John Doe',
        duration: '60 minutes',
        date: 'September 12, 2024',
        summary: 'An in-depth exploration of sustainable practices in architecture, focusing on materials, energy efficiency, and environmental impact.',
        topics: [
            'Principles of Sustainable Design',
            'Eco-friendly Building Materials',
            'Energy-efficient Building Systems',
            'Case Studies of Sustainable Buildings'
        ]
    },
    {
        id: 3,
        title: 'Architectural History: Gothic to Baroque',
        instructor: 'Dr. Emily Johnson',
        duration: '50 minutes',
        date: 'September 15, 2024',
        summary: 'This lecture covers the evolution of architectural styles from the Gothic period through to the Baroque era, highlighting key structures and their significance.',
        topics: [
            'Gothic Architecture: Features and Examples',
            'Transition to Renaissance Architecture',
            'Baroque Architecture: Opulence and Grandeur',
            'Comparative Analysis of Gothic and Baroque Styles'
        ]
    },
    {
        id: 4,
        title: 'Urban Planning and Design',
        instructor: 'Prof. Michael Lee',
        duration: '55 minutes',
        date: 'September 17, 2024',
        summary: 'A comprehensive overview of urban planning principles and how they influence the design and development of cities.',
        topics: [
            'Foundations of Urban Planning',
            'Zoning Laws and Regulations',
            'Public Spaces and Their Importance',
            'Challenges in Modern Urban Design'
        ]
    },
    {
        id: 5,
        title: 'Digital Tools in Architecture',
        instructor: 'Dr. Sarah Davis',
        duration: '40 minutes',
        date: 'September 20, 2024',
        summary: 'Explores the role of digital tools in modern architecture, including software for design, modeling, and project management.',
        topics: [
            'Introduction to BIM (Building Information Modeling)',
            'CAD Software for Architects',
            '3D Rendering and Visualization Tools',
            'Future Trends in Architectural Technology'
        ]
    }
];


const PublicLecture = () => {

    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Typology</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."/>
            </Helmet>
            <StyledComponent>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <ListComponent url={'typology'} data={data} />
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`


`;

export default PublicLecture;
